<template>
  <div>
    <div class="page-hero">
      <div class="container">
        <span class="section__label">Возможности</span>
        <h1 class="page-hero__title">Полный контроль над мотивацией</h1>
        <p class="page-hero__text">Все инструменты для гибкой настройки, автоматического расчёта и прозрачного отображения мотивационных выплат.</p>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <div v-for="block in blocks" :key="block.title" class="feature-block">
          <div class="feature-block__icon">
            <ui-icon :name="block.icon" :size="32" />
          </div>
          <div class="feature-block__content">
            <h2 class="feature-block__title">{{ block.title }}</h2>
            <p class="feature-block__text">{{ block.text }}</p>
            <ul class="feature-block__list">
              <li v-for="item in block.items" :key="item">{{ item }}</li>
            </ul>
            <div v-if="block.shot" class="feature-block__shot">
              <img :src="block.shot" :alt="block.title" loading="lazy">
            </div>
          </div>
        </div>
      </div>
    </section>

    <cta-section />
  </div>
</template>

<script>
import CtaSection from '../components/home/CtaSection.vue'
import UiIcon from '../components/ui/UiIcon.vue'
export default {
  name: 'FeaturesPage',
  components: { CtaSection, UiIcon },
  data() {
    return {
      blocks: [
        {
          icon: 'network',
          title: 'Оргструктура компании',
          text: 'Подразделения, должности и сотрудники в одной интерактивной схеме — основа для всех расчётов и прав доступа.',
          items: ['Дерево подразделений и должностей', 'Сотрудники и физлица', 'Импорт структуры из Excel', 'Разграничение доступа по дереву'],
          shot: '/img/docs/hr/structure-add.png',
        },
        {
          icon: 'calculator',
          title: 'Автоматический расчёт премий',
          text: 'Система считает премии по всей компании за период — по вашим формулам, без ручного труда.',
          items: ['Расчёт по всей организации за минуты', 'Плановые и фактические показатели', 'Коэффициенты, шкалы, формулы-корректировки', 'История изменений каждого значения'],
          shot: '/img/docs/hr/calculation-group.png',
        },
        {
          icon: 'layers',
          title: 'Двухконтурный расчёт',
          text: 'Один расчёт в двух контурах: онлайн-оценка сотруднику в любой момент и авторитетный серверный прогон для ведомости.',
          items: ['Контур 1 — мгновенная онлайн-оценка сотруднику', 'Контур 2 — серверный расчёт по всей компании', 'Закрытие периода от случайных правок', 'Серверный итог — единый источник для бухгалтерии'],
        },
        {
          icon: 'target',
          title: 'Конструктор формул',
          text: 'Соберите ваши правила премирования из готовых блоков — без программиста.',
          items: ['Произведение факторов: база × коэффициенты × факт/план', 'Шкалы и ступени', 'Формулы-корректировки со знаком минус — итог части не уходит ниже нуля', 'Коэффициенты части, включая ручной коэффициент руководителя с границами'],
          shot: '/img/docs/hr/formula-add.png',
        },
        {
          icon: 'clipboard-list',
          title: 'Формула как в Положении',
          text: 'Каждая формула отображается в математической записи — с именами переменных для документов и с подставленными числами для сотрудника.',
          items: ['Математическая запись формулы', 'Расшифровка «как посчитано» с числами', 'Единый источник: изменили формулу — изменилась запись'],
        },
        {
          icon: 'file-text',
          title: 'Положение о премировании',
          text: 'Расчётные разделы система собирает автоматически из ваших формул, показателей и параметров — вам остаётся дополнить вводные разделы и сохранить в PDF.',
          items: ['Виды и размеры премий, показатели и порядок расчёта — автоматически из формул', 'Приложения: параметры и шкалы коэффициентов', 'Вводные разделы и подписант — заполняете сами', 'Печать и сохранение в PDF'],
        },
        {
          icon: 'gauge',
          title: 'Показатели эффективности (KPI-карта)',
          text: 'У каждого сотрудника — карта показателей с весами; её итог автоматически идёт множителем в формулу премии.',
          items: ['Показатель — из справочника, свой или каскадом от KPI руководителя', 'Итог = Σ(вес × %) ÷ Σ весов, веса не обязательно сводить к 100%', 'Готовый коэффициент подставляется в премию', 'Отдельный раздел «Показатели эффективности» у сотрудника'],
        },
        {
          icon: 'bar-chart',
          title: 'Стратегия и KPI',
          text: 'Свяжите премии со стратегией: цели, перспективы и ключевые индикаторы эффективности по подразделениям.',
          items: ['Стратегические цели и перспективы', 'Ключевые индикаторы (KPI)', 'KPI команды для руководителя', 'Связь целей компании с мотивацией'],
          shot: '/img/docs/hr/strategy-add.png',
        },
        {
          icon: 'users',
          title: 'Роли и разграничение прав',
          text: 'Четыре роли — сотрудник, руководитель, HR, админ. Каждый видит и правит только положенное, а роли руководителя и HR делегируются на подразделение каскадом.',
          items: ['Настройки расчёта (показатели, формулы, структуру) правят только HR и админ', 'Руководитель видит свою ветку и согласует KPI, но настройки не меняет и расчёт не запускает', 'Сотрудник видит только свою «Мотивацию» — приватность зарплат', 'Делегирование руководителя/HR на подразделение — каскадом по дереву структуры'],
        },
        {
          icon: 'send',
          title: 'Ведомость и данные',
          text: 'Кадры из 1С, выработка из учётной системы — один расчёт вместо ежемесячного сведения двух выгрузок вручную.',
          items: ['Кадровые данные из 1С: оклады, ставки, табель', 'Выработка и выручка из учётной системы', 'Ручной ввод значений', 'Расчётная ведомость в Excel/CSV под загрузку в 1С'],
        },
        {
          icon: 'eye',
          title: 'Онлайн-просмотр расчёта',
          text: 'Руководитель видит премии своей команды, сотрудник — свою премию и пошаговый расчёт, в любой момент периода.',
          items: ['Своя премия онлайн в любой момент периода', 'Премии и KPI подчинённых для руководителя', 'Пошаговая расшифровка расчёта'],
        },
        {
          icon: 'folder',
          title: 'Задачи и проекты',
          text: 'Канбан-доски для команд: ставьте задачи, делегируйте и контролируйте сроки — в том числе из Telegram.',
          items: ['Проекты, колонки и карточки задач', 'Делегирование и исполнители', 'Контроль сроков', 'Управление задачами из Telegram-бота'],
          shot: '/img/docs/manager/task-add.png',
        },
        {
          icon: 'bell',
          title: 'Интеграции и уведомления',
          text: 'CandB.pro связан с привычными инструментами и сообщает об изменениях в реальном времени.',
          items: ['Импорт оргструктуры и данных из Excel', 'Telegram: вход по коду и бот-ассистент', 'Уведомления о расчётах в реальном времени', 'Корпоративная почта внутри системы'],
        },
        {
          icon: 'moon',
          title: 'Современный интерфейс',
          text: 'Кабинет, которым приятно пользоваться: тот же расчёт — на десктопе, планшете и телефоне.',
          items: ['Светлая и тёмная темы', 'Адаптив под телефон и планшет', 'Уведомления-тосты вместо системных окон', 'Доступность и удобная навигация'],
        },
        {
          icon: 'link',
          title: 'В разработке',
          text: 'Ближайшие планы развития — по запросам пилотных компаний.',
          items: ['Выгрузка Положения и приказа о премировании в Word (.docx)', 'Прямая интеграция с 1С:ЗУП', 'Согласование премий руководителем', 'Расширение REST API'],
        },
      ],
    }
  },
}
</script>

<style scoped>
.page-hero {
  background: linear-gradient(135deg, #1E3A8A, #2563EB);
  color: white;
  padding: 140px 0 80px;
}
.page-hero__title {
  font-size: 2.75rem;
  font-weight: 800;
  margin: 12px 0 16px;
}
.page-hero__text {
  font-size: 1.125rem;
  opacity: 0.85;
  max-width: 560px;
}
.feature-block {
  display: flex;
  gap: 40px;
  padding: 48px 0;
  border-bottom: 1px solid var(--border);
}
.feature-block:last-child { border-bottom: none; }
.feature-block__icon {
  width: 72px; height: 72px;
  background: var(--primary-light);
  color: var(--primary);
  border-radius: var(--radius);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.feature-block__title {
  font-size: 1.375rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--dark);
}
.feature-block__text {
  color: var(--gray);
  margin-bottom: 20px;
  font-size: 1rem;
  line-height: 1.65;
}
.feature-block__list {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 32px;
}
.feature-block__list li {
  color: var(--dark);
  font-size: 0.9375rem;
  padding-left: 20px;
  position: relative;
}
.feature-block__list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--secondary);
  font-weight: 700;
}
.feature-block__shot {
  margin-top: 24px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  max-width: 640px;
}
.feature-block__shot img {
  display: block;
  width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .feature-block { flex-direction: column; gap: 20px; }
  .feature-block__list { grid-template-columns: 1fr; }
  .page-hero__title { font-size: 2rem; }
}
</style>
